$(function(){
	var initialFilter = 'all';
	var hash = window.location.hash.replace(/^#/g, '');

	if (hash) {
		// Normalize: strip any leading _ then add it back (handles both #UUID and #_UUID links)
		initialFilter = '._' + hash.replace(/^_+/, '');
	}

	var mixer = null;

	function setHash(state) {
		var selector = state.activeFilter.selector || '';
		var isAll = !selector || selector === 'all' || selector === '.mix';
		var newHash = '#' + selector.replace(/^\._?/, '');

		if (isAll && window.location.hash) {
			history.pushState(null, document.title, window.location.pathname);
		} else if (!isAll && newHash !== window.location.hash) {
			history.pushState(null, document.title, window.location.pathname + newHash);
		}
	}

	var mixerConfig = {
		selectors: {
			target: '.mix'
		},
		controls: {
			scope: 'global'
		},
		animation: {
			enable: false
		},
		callbacks: {
			onMixEnd: setHash
		}
	};

	document.body.addEventListener('htmx:afterSwap', function(evt) {
		if (evt.detail.xhr.status === 200) {
			var filter = mixer ? 'all' : initialFilter;
			if (mixer) {
				mixer.destroy();
			}
			mixer = mixitup('#portfolio', $.extend(true, {}, mixerConfig, {
				load: { filter: filter }
			}));
		}
	});

});
